/* tslint:disable:jsx-no-lambda WI:47677 */
import * as React from 'react';
import {
    DetailsList,
    SelectionMode,
    ConstrainMode,
    IColumn,
} from 'office-ui-fabric-react/lib/DetailsList';
import { observer } from 'mobx-react-lite';

export interface DiagnosticsTableProps {
    header: { [field: string]: string };
    datapoints: any[];
}

const DiagnosticsTable = observer(function DiagnosticsTable(props: DiagnosticsTableProps) {
    let columns: IColumn[];
    if (props.header) {
        columns = [];

        for (let field of Object.keys(props.header)) {
            columns.push({
                key: field,
                minWidth: 0,
                name: props.header[field],
                fieldName: field,
            });
        }
    }

    return (
        <DetailsList
            items={props.datapoints}
            columns={columns}
            selectionMode={SelectionMode.none}
            constrainMode={ConstrainMode.unconstrained}
            onRenderItemColumn={(item, index, column) => {
                return <span>{item[column.key]}</span>;
            }}
        />
    );
});
export default DiagnosticsTable;
